var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("breadcrumb", { attrs: { breadcrumbConfig: _vm.breadcrumbConfig } }),
      _vm._m(0),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("h3", [_vm._v(" 列表数据")]),
          _c("orders-list-table", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            attrs: {
              dataList: _vm.page.list,
              heightStr: _vm.columns.height,
              parArrayArr: _vm.parArray,
              config: _vm.columns.config,
              typeStr: _vm.columns.type,
            },
            on: {
              tableSelectionChange: _vm.handleSelectionChange,
              onTableShowDialogCom: _vm.resTableShowDialog,
              onRevocationAfterSales: _vm.cancelAfterSales,
              onConfirmTakeChange: _vm.onConfirmReceipt,
              loginDialog: _vm.loginDialog,
              loginDialogRecord: _vm.loginDialogRecord,
            },
          }),
          _c(
            "div",
            { staticClass: "page" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "current-page": _vm.page.currentPage,
                  "page-sizes": [3, 5, 10, 20, 50],
                  "page-size": _vm.page.pageSize,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.page.totalNum,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.page, "currentPage", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.page, "currentPage", $event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialog.title,
            visible: _vm.dialog.visible,
            width: _vm.dialog.width,
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialog, "visible", $event)
            },
          },
        },
        [
          _vm.dialog.type === "afterSaleShenhe"
            ? [
                _c("audit-operation", {
                  ref: "afterSaleShenhe",
                  attrs: {
                    orderObj: _vm.dialog.row,
                    afterNos: _vm.multipleSelection,
                  },
                  on: { submitState: _vm.shenheState },
                }),
              ]
            : _vm._e(),
          _vm.dialog.type === "cancelService"
            ? [
                _c("div", { staticClass: "cancellation-reason" }, [
                  _c("h3", [_vm._v("是否撤回售后申请？撤回后会取消审核。")]),
                  _c("div", { staticClass: "cancellation-left" }, [
                    _vm._v("取消原因"),
                  ]),
                  _c(
                    "div",
                    { staticClass: "cancellation-right" },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          placeholder: "请输入取消原因（非必填）",
                          maxlength: "200",
                          rows: "5",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.cancellationReason,
                          callback: function ($$v) {
                            _vm.cancellationReason = $$v
                          },
                          expression: "cancellationReason",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "dialogBtnright dialogBtnright_right",
                    staticStyle: { "margin-top": "20px" },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "setPay_payment_btn_quxiao",
                        on: {
                          click: function ($event) {
                            _vm.dialog.visible = false
                          },
                        },
                      },
                      [_vm._v("取 消")]
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "setPay_payment_btn_queren",
                        attrs: { type: "primary" },
                        on: { click: _vm.handlerCloseOrderSubmit },
                      },
                      [_vm._v("确 定")]
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.dialog.type === "modifyOrderNoOne" ||
          _vm.dialog.type === "modifyOrderNoTwo" ||
          _vm.dialog.type === "modifyOrderNoOneTui"
            ? [
                _c("modify-order-no", {
                  ref: "modifyOrderNo",
                  attrs: { orderObj: _vm.dialog.row, type: _vm.dialog.type },
                  on: { submitState: _vm.modifyState },
                }),
              ]
            : _vm._e(),
          _vm.dialog.type === "2" || _vm.dialog.type === "progress"
            ? [
                _c("step-progress", {
                  attrs: {
                    orderObj: _vm.dialog.row,
                    type: "2",
                    source: "after",
                  },
                }),
              ]
            : _vm._e(),
          _vm.dialog.type === "shenheStep"
            ? [
                _c("step-progress", {
                  attrs: {
                    orderObj: _vm.dialog.row,
                    type: "shenheStep",
                    processFunc: _vm.dictionaries.process_func,
                    source: "after",
                  },
                }),
              ]
            : _vm._e(),
          _vm.dialog.type !== "progress" &&
          _vm.dialog.type !== "cancelService" &&
          _vm.dialog.type !== "shenheStep" &&
          _vm.dialog.type !== "2"
            ? _c(
                "div",
                { staticClass: "dialog-but" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", plain: "" },
                      on: { click: _vm.closeDialog },
                    },
                    [_vm._v("取消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.actionDialog },
                    },
                    [_vm._v("确认")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "售后件登记",
            visible: _vm.isRegister,
            "append-to-body": true,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isRegister = $event
            },
          },
        },
        [
          [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  height: "54px",
                  "margin-left": "40px",
                },
              },
              [
                _c("div", [
                  _c("img", {
                    staticStyle: { width: "72px", height: "54px" },
                    attrs: { src: _vm.loginObj.goodsImage },
                  }),
                ]),
                _c(
                  "div",
                  {
                    staticStyle: {
                      height: "54px",
                      display: "flex",
                      "flex-direction": "column",
                      "justify-content": "space-between",
                      "margin-left": "20px",
                    },
                  },
                  [
                    _c("div", [_vm._v(_vm._s(_vm.loginObj.goodsName))]),
                    _c(
                      "div",
                      {
                        staticStyle: { color: "#999999", "font-size": "12px" },
                      },
                      [_vm._v(_vm._s(_vm.loginObj.goodsSkuName))]
                    ),
                  ]
                ),
              ]
            ),
            _c(
              "el-form",
              {
                ref: "loginForm",
                staticStyle: { "margin-top": "20px" },
                attrs: {
                  inline: true,
                  model: _vm.loginForm,
                  size: "small",
                  "label-width": "120px",
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "完好" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "400px" },
                      attrs: { placeholder: "请输入" },
                      model: {
                        value: _vm.loginForm.intact,
                        callback: function ($$v) {
                          _vm.$set(_vm.loginForm, "intact", $$v)
                        },
                        expression: "loginForm.intact",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "破损" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "400px" },
                      attrs: { placeholder: "请输入" },
                      model: {
                        value: _vm.loginForm.damaged,
                        callback: function ($$v) {
                          _vm.$set(_vm.loginForm, "damaged", $$v)
                        },
                        expression: "loginForm.damaged",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "漏件" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "400px" },
                      attrs: { placeholder: "请输入" },
                      model: {
                        value: _vm.loginForm.missingParts,
                        callback: function ($$v) {
                          _vm.$set(_vm.loginForm, "missingParts", $$v)
                        },
                        expression: "loginForm.missingParts",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "是否理赔" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "400px" },
                        attrs: { placeholder: "请选择是否理赔", clearable: "" },
                        on: { change: _vm.selectClaimFlag },
                        model: {
                          value: _vm.loginForm.claimFlag,
                          callback: function ($$v) {
                            _vm.$set(_vm.loginForm, "claimFlag", $$v)
                          },
                          expression: "loginForm.claimFlag",
                        },
                      },
                      [
                        _c("el-option", {
                          key: "1",
                          attrs: { label: "是", value: 1 },
                        }),
                        _c("el-option", {
                          key: "0",
                          attrs: { label: "否", value: 0 },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "快递理赔金额" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "400px" },
                      attrs: {
                        disabled: _vm.loginForm.claimFlag == "0",
                        placeholder: "请输入",
                      },
                      model: {
                        value: _vm.loginForm.claimAmount,
                        callback: function ($$v) {
                          _vm.$set(_vm.loginForm, "claimAmount", $$v)
                        },
                        expression: "loginForm.claimAmount",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "备注" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "400px" },
                      attrs: { placeholder: "请输入" },
                      model: {
                        value: _vm.loginForm.remarks,
                        callback: function ($$v) {
                          _vm.$set(_vm.loginForm, "remarks", $$v)
                        },
                        expression: "loginForm.remarks",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                staticStyle: {
                  "margin-top": "20px",
                  float: "right",
                  "margin-bottom": "20px",
                },
              },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "setPay_payment_btn_quxiao",
                    attrs: { type: "primary", plain: "" },
                    on: {
                      click: function ($event) {
                        _vm.isRegister = false
                      },
                    },
                  },
                  [_vm._v("取消")]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "setPay_payment_btn_queren",
                    attrs: { type: "primary" },
                    on: { click: _vm.submitLoginForm },
                  },
                  [_vm._v("提交")]
                ),
              ],
              1
            ),
          ],
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "登记历史",
            visible: _vm.isRegisterRecord,
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isRegisterRecord = $event
            },
          },
        },
        [[_c("timeLine", { attrs: { timeLineData: _vm.timeLineData } })]],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "content page-title" }, [
      _c("h2", [_vm._v("售后记录")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }